export default __webpack_public_path__ + "static/media/wi-rain-mix.d2dbec86.svg";